import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';

class RegistrationScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNumber: '',
    };
  }

  componentDidMount() {
    this.setState({mobileNumber: this.props.mobileNumber});
  }

  handleChange = (name) => (event) => {
    if (name === 'name') {
      this.setState({name: event.target.value});
    }

    if (name === 'mobilenumber') {
      this.setState({mobileNumber: event.target.value});
    }

    if (name === 'email') {
      this.setState({email: event.target.value});
    }
  };

  render() {
    const loginContainerStyle = {
      padding: '14px',
    };

    const inputbxStyle = {
      width: '100%',
    };

    const btnOtpStyle = {
      padding: '14px 16px',
    };

    const title = (
      <div className="title-img-center">
        <img
          src="https://www.confirmtkt.com/img/horizontal.png"
          alt="confirmtkt_logo"
          height="40"
        />
        <br />
        <div id="">SIGN UP(New User)</div>
      </div>
    );

    const registrationForm = (
      <div>
        <TextField
          label="Enter Name"
          value={this.state.name ? this.state.name : ''}
          id="name"
          type="text"
          style={inputbxStyle}
          onChange={this.handleChange('name')}
        />
        <br />
        <br />
        <TextField
          label="Enter Email"
          value={this.state.email ? this.state.email : ''}
          id="name"
          type="email"
          style={inputbxStyle}
          onChange={this.handleChange('email')}
        />
        <br />
        <br />
        <TextField
          label="Enter your Mobile Number"
          value={this.state.mobileNumber ? this.state.mobileNumber : ''}
          id="mobile-number"
          type="number"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">+91</InputAdornment>
            ),
          }}
          style={inputbxStyle}
          onChange={this.handleChange('mobilenumber')}
        />
        <br />
        <br />
        <Button
          variant="contained"
          className="ctkt-btn-success zero-border-radius"
          style={btnOtpStyle}
        >
          GET OTP
        </Button>
      </div>
    );

    return (
      <div className="text-align-center" style={loginContainerStyle}>
        {title}
        {registrationForm}
      </div>
    );
  }
}

export default RegistrationScreen;
